import { useGetClaimsForCurrentUser } from '../api/user/user';
import { useSystemYear } from './useSystemYear';

/**
 * Hook to determine if the collaboration UI is enabled
 * If the system year is before 2026
 * OR if the user is in the CollaborationUsers group,
 * @returns true if the collaboration UI is enabled
 */
export const useIsCollaborationUIEnabled = () => {
    const { data: claims } = useGetClaimsForCurrentUser();
    const systemYear = useSystemYear();

    return (systemYear && systemYear < 2026) || claims?.isCollaborationUser || false;
};
